import { gql, useLazyQuery } from "@apollo/client";
import {
  CustomerListForStatisticsQuery,
  CustomerListForStatisticsQueryVariables,
} from "@/gql/graphql";

export const customerListForStatisticsQuery = gql`
  query CustomerListForStatistics(
    $filterOptions: StatisticsSearchCustomerListByFilterOptions!
  ) {
    statistics {
      customerList {
        byFilter(filterOptions: $filterOptions) {
          items {
            customerName
            customerNumber
            negotiationStatus
            parentNumber
            sellerId
            statNumber
            volumeAndTargetForSelected {
              averageNegotiationRate
              averageTarget
              avgMeterPrice
              avgMeterPriceDiffInPercent
              expectedVolume
              lastYearVolume
            }
          }
        }
      }
    }
  }
`;

export const useCustomerListQuery = () => {
  const [fetchCustomerList, { data, loading, error }] = useLazyQuery<
    CustomerListForStatisticsQuery,
    CustomerListForStatisticsQueryVariables
  >(customerListForStatisticsQuery, {
    fetchPolicy: "network-only",
  });

  return {
    customerList: data?.statistics?.customerList,
    loading,
    error,
    fetchCustomerList,
  };
};
